import { customElement } from 'lit/decorators.js';
import { styles } from './asc-form-wrapper.styles';

/**
 * Zero-shadow-DOM wrapper that injects Ascensus design-system styles onto
 * native form elements. Wrap Umbraco Forms output in `<asc-form-wrapper>`
 * and native `<input>`, `<textarea>`, `<select>`, checkboxes, radios, labels,
 * hints, and validation errors are styled to match the design system.
 *
 * ```html
 * <asc-form-wrapper>
 *   @await Html.PartialAsync("Form", Model)
 * </asc-form-wrapper>
 * ```
 *
 * @element asc-form-wrapper
 */
@customElement('asc-form-wrapper')
export class AscFormWrapper extends HTMLElement {
  private static _injected = false;

  connectedCallback(): void {
    AscFormWrapper._injectStyles();
  }

  private static _injectStyles(): void {
    if (AscFormWrapper._injected) return;
    AscFormWrapper._injected = true;

    if (styles.styleSheet) {
      document.adoptedStyleSheets = [...document.adoptedStyleSheets, styles.styleSheet];
    } else {
      const el = document.createElement('style');
      el.textContent = styles.cssText;
      document.head.appendChild(el);
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'asc-form-wrapper': AscFormWrapper;
  }
}
